/**
 * Routes whose screen depends on the viewer's role. Keeping the switch here
 * means feature pages never branch on role for layout-level decisions.
 */
import { lazy } from "react";

import { useMe } from "@/api/hooks/auth";

const InstructorDashboardPage = lazy(() => import("./insights/InstructorDashboardPage"));
const LearnerDashboardPage = lazy(() => import("./learner/LearnerDashboardPage"));
const InstructorCoursesPage = lazy(() => import("./instructor/InstructorCoursesPage"));
const LearnerCoursesPage = lazy(() => import("./learner/LearnerCoursesPage"));
const CourseLayout = lazy(() => import("./instructor/CourseLayout"));
const LearnerCoursePage = lazy(() => import("./learner/LearnerCoursePage"));

export function HomeRoute() {
  return useMe()?.role === "instructor" ? <InstructorDashboardPage /> : <LearnerDashboardPage />;
}

export function CoursesRoute() {
  return useMe()?.role === "instructor" ? <InstructorCoursesPage /> : <LearnerCoursesPage />;
}

/** Instructors get the tabbed course workspace (nested routes); learners get the course page. */
export function CourseRoute() {
  return useMe()?.role === "instructor" ? <CourseLayout /> : <LearnerCoursePage />;
}
